<template>
	<v-card flat tile class="pa-3">
		<v-row class="ma-0 mt-4">
			<v-col>
				<v-select
					label="Instructions"
					v-model="project.instruction"
					:items="instructions"
					item-value="id"
					item-text="name"
					:append-icon="selectIcon('instruction')"
					:prepend-icon="dialogIcon('instruction')"
					@click:append="project.instruction = false"
					@click:prepend="instructionDialog = true"
					v-on:mousedown="fetch('instructions')"
				></v-select>
				<v-dialog v-model="instructionDialog">
					<v-sheet v-if="projectInstruction">
						<EditInstruction :instruction="projectInstruction"></EditInstruction>
					</v-sheet>
					<v-sheet v-else>
						<NewInstructionForm v-on:created="setValue"></NewInstructionForm>
					</v-sheet>
				</v-dialog>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-text-field v-model="project.invite.clientName" label="Client Name"></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-text-field v-model="project.invite.description" label="Project Description"></v-text-field>
			</v-col>
		</v-row>		
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field v-model="project.invite.argument1" label="Argument 1"></v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field v-model="project.invite.argument2" label="Argument 2"></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="10">
				<v-text-field v-model="project.invite.regLink" label="Registration Link"></v-text-field>			
			</v-col>
			<v-col cols="2">
				<v-text-field v-model="project.incentiveAmount" label="Incentive"></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-btn color="primary" @click="sendTest">Send Test To Yourself</v-btn>
			</v-col>
		</v-row>
		<v-snackbar v-model="testSent" light>
			Test Sent
			<v-btn color="green" text @click="testSent = false">Close </v-btn>
		</v-snackbar>			
		<p class="text-right">
			<v-btn
				color="green"
				dark
				class="mr-4"
				@click="$emit('save')"
				>Save
			</v-btn>			
		</p>
	</v-card>
</template>

<script type="text/javascript">
	import Vuex from 'vuex'
	export default{
		name: "EditProjectInvites", 
		props: {
			project: {type: Object },
		}, 
		components:{
			EditInstruction: () => import("../../components/edits/EditInstruction"),
			NewInstructionForm: () => import("../../components/forms/NewInstructionForm"),
		},
		data: () =>{
			return {
				instructionDialog: false,
				fetched: [],
				testSent: false
			}
		}, 
		computed: {    
			...Vuex.mapState({
				user: state => state.auth.user,
				organisations: state => state[state.auth.view].organisations,
				instructions: state => state[state.auth.view].instructions,
			}),
			inviteInfo: function(){
				return this.project.inviteInfo ? this.project.inviteInfo : ['',''] 
			},		
			projectClient() {
				const self = this;
				return self.organisations.find( i => i.id == self.project.client)
			},
		},
		methods: {
			setValue(value, key){
				if( key == 'survey' ){ key = "screener"; }
				if( key == 'organisation' ){ key = "client"; }
				this.project[key] = value;
				this[key + 'Dialog'] = false;
			},
			dialogIcon(key){
				if( this.project[key] ){
					return "mdi-pencil-circle"
				}
				else{
					return "mdi-plus-circle"
				}
			},
			selectIcon(key){
				if( this.project[key] ){
					return "mdi-close"
				}
				else{
					return "mdi-chevron-down"
				}
			},
			fetch(type){
				if( this.fetched.indexOf(type) < 0 ){				
					this.fetched.push(type)
					this.$store.dispatch("fetch", type )
				}
			},
			sendTest(){
				const self = this;
				let contactEvent = {
					direction: "outbound",
					batch: true, 
					test: true,
					recipient: self.user.uid, 
					sender: self.user.uid, 
					sendGridMessage: 'd-d17de2bb39554b089b597e477e14b47e' , 
					channel: "email", 
					messageType: "templateMessage", 
					project: self.project.id,
					sendStatus: "unsent"
				}
				self.$store.dispatch("addDoc", {
					collection: "contactEvents",
					data: contactEvent
				}).then( () => {
					self.testSent = true;
				}) 
				// const newSendMail = {
				// 	toUids: [self.user.uid], 
				// 	template: "invite", 
				// 	data: {
				// 		topic: ""
				// 	}
				// }
				// self.$store.dispatch("addDoc", {
				// 	collection: "sendMail",
				// 	data: newSendMail
				// }).then( () => {
				// 	self.testSent = true;
				// }) 
			}
		},
		watch: {
			projectClient: {
				immediate: true,
				handler() {
					if( !this.project.invite ){
						this.project.invite = {}
					}
					if( !this.project.invite.clientName ){
						this.project.invite.clientName = this.projectClient.name;
					}
				}
			}
		},
		created(){
			const self = this;
			if( !self.project.invite ){
				self.project.invite = {	}
			}
			if( self.project.screener ){
				self.$store.dispatch("fetchNamedUrl", {objectId: self.project.screener, type: "survey"} ).then( url => {
					if( url ){
						self.project.invite.regLink = window.location.origin + "/" +  url;
					}
				
					
				})
			}
		}

	}
</script>